import type { ReactNode } from "react";
import classNames from "classnames";

export const Container = ({
  className,
  children,
}: {
  className?: string;
  children: ReactNode;
}) => (
  <div className={classNames("flex flex-col gap-6", className)}>{children}</div>
);
